import { render, staticRenderFns } from "./UploadPrintPage.vue?vue&type=template&id=2467a8ad&"
import script from "./UploadPrintPage.vue?vue&type=script&lang=js&"
export * from "./UploadPrintPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports